'use client';
import LargeCarousel from '@/components/carousel/large-carousel';
import { useLocale } from 'next-intl';
import { DestinationValue } from '@/types/cms';

export type CarouselSectionItem = {
  slides: {
    ArabicImage: string;
    EnglishImage: string;
    DestinationValue: DestinationValue;
    Destination: number;
  }[];
};

const Banner = (props: CarouselSectionItem) => {
  const localActive = useLocale();

  return (
    <LargeCarousel
      slides={props.slides?.map((item) => ({
        image: localActive === 'ar' ? item.ArabicImage : item.EnglishImage,
        DestinationValue: item.DestinationValue,
        Destination: item.Destination,
      }))}
    />
  );
};

export default Banner;
